import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { Observable } from 'rxjs/Observable';
import { ItemGeneralListado } from 'app/helpers/components/itemClasses/itemListadoGeneral.class';


@Injectable()
export class SOCUsersConfigService {
  private url = 'api/configSocUsers';

  constructor(private sxHttp: SxHttpService) { }

  /**
   * Dado un tipo de select, retorna el listado de opciones que hidratan el
   * select correspondiente a ese tipo de select
   */
  getConfiguration(mode:string): Observable<ItemGeneralListado[]> {
    const url = this.url + '/GetConfiguration/' + mode;

    return this.sxHttp.get(url)
      .map(response => {
        let elements:ItemGeneralListado[] = [ ];
        (response.json().data as any[]).forEach(element => {
          const append:ItemGeneralListado={
            id: element.id, 
            Titulo: element.titulo,
            Descripcion: element.descripcion ,
            Imagen: this.getIconoComando(element.titulo),
            UrlDestination: null
          }
          elements.push(append);
        });

        return elements;
            });
  }
 
  /**
   * Retorna el icono que representa al comando
   *
   * @param codComando El id del comando
   */
  getIconoComando(codComando: string): string {
    const mapping = {
      Alta: 'fa fa-3x fa-user-plus',
      AltaExpress: 'fa fa-3x fa-angle-double-right',
      Blanqueo: 'fa fa-3x fa-user-o',
      Bloqueo: 'fa fa-3x fa-user-times',
      CambioPassword: 'fa fa-3x fa-lock',
      Consulta: 'fa fa-3x fa-question',
      Edicion: 'fa fa-3x fa-pencil-alt-square-o',
      Listado: 'fa fa-3x fa-list',
      Login: 'fa fa-3x fa-sign-in',
      Delete: 'fa fa-3x fa-trash',
      RolesAdministracion: 'fa fa-3x fa-user-secret'
    };
    return mapping[codComando];
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/socUserConfig.service.ts